import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/computer-with-clock.svg'


const _hoisted_1 = {
  id: "modal-plugin-execution-confirmation",
  class: "modal modal-md fade",
  tabindex: "-1"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-body py-3" }
const _hoisted_5 = { class: "fs-6 text-center mt-4" }
const _hoisted_6 = {
  href: "../faq/digital-certificate-plugin",
  target: "_blank",
  rel: "noopener noreferrer",
  class: "link ms-2"
}
const _hoisted_7 = { class: "modal-footer py-3" }
const _hoisted_8 = ["disabled"]

import { Modal } from 'bootstrap'
  import IconComponent from '../../../components/Atoms/Icon.vue'
  import CheckBox from '../components/Atoms/CheckBox.vue'

  import {
    checkIfPluginIsInstalled,
    createPluginConnection,
  } from '../services/pluginHttps'
  import { useModalControl } from '../store/pinia/useModalControl.store'
  import usePluginNotExecutingModal from '../composables/usePluginNotExecutingModal'

  import { ref, onMounted, computed } from 'vue'

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ModalPluginExecutionConfirmation',
  emits: ['retryCertificateIssuing'],
  setup(__props, { expose: __expose, emit: __emit }) {

  const emit = __emit
  const modal = ref<InstanceType<typeof Modal> | null>(null)
  const modalControlStore = useModalControl()
  const { showPluginNotExecutingModal, hidePluginNotExecutingModal } =
    usePluginNotExecutingModal()

  const pluginExecutionChecker = ref<any>(null)
  const pluginExecutionUserConfirmation = ref(false)
  const pluginExecution = ref(false)

  const canProceed = computed(() => pluginExecutionUserConfirmation.value)

  onMounted(() => {
    modal.value = new Modal('#modal-plugin-execution-confirmation', {
      backdrop: 'static',
      keyboard: false,
    })
  })

  function clearPluginExecutionChecker() {
    clearInterval(pluginExecutionChecker.value)
  }

  function hide() {
    clearPluginExecutionChecker()
    pluginExecutionUserConfirmation.value = false
    pluginExecution.value = false
    modal.value?.hide()
  }

  function setPluginExecutionChecker() {
    let waitingPromiseResolve = false

    pluginExecutionChecker.value = setInterval(async () => {
      try {
        if (waitingPromiseResolve) {
          return
        }

        waitingPromiseResolve = true

        await createPluginConnection()

        const isPluginInstalled = await checkIfPluginIsInstalled()

        if (isPluginInstalled) {
          pluginExecution.value = true
          clearPluginExecutionChecker()
          emit('retryCertificateIssuing')
          hide()
        }
      } catch (error) {
        pluginExecution.value = false
      }

      waitingPromiseResolve = false
    }, 1000)
  }

  function show() {
    setPluginExecutionChecker()
    modal.value?.show()
  }

  async function fakeCheck() {
    if (!pluginExecution.value) {
      modalControlStore.show({
        modalId: 'pluginNotExecutingModal',
        show: showPluginNotExecutingModal,
        hide: hidePluginNotExecutingModal,
      })
    }

    hide()
  }

  __expose({ show, hide })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[3] || (_cache[3] = _createElementVNode("img", {
            alt: "sucesso",
            src: _imports_0
          }, null, -1)),
          _cache[4] || (_cache[4] = _createElementVNode("p", { class: "fs-6 text-center mt-4" }, [
            _createElementVNode("strong", null, "Agora precisamos de você! Clique duas vezes"),
            _createTextVNode(" no arquivo baixado "),
            _createElementVNode("strong", null, "para executá-lo"),
            _createTextVNode(". ")
          ], -1)),
          _createVNode(CheckBox, {
            modelValue: pluginExecutionUserConfirmation.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((pluginExecutionUserConfirmation).value = $event)),
            label: "Executei o plugin no meu computador.",
            type: "success"
          }, null, 8, ["modelValue"]),
          _createElementVNode("p", _hoisted_5, [
            _cache[2] || (_cache[2] = _createElementVNode("strong", null, "Não sabe executar o plugin?", -1)),
            _createElementVNode("a", _hoisted_6, [
              _cache[1] || (_cache[1] = _createElementVNode("span", { class: "me-2" }, "Clique aqui", -1)),
              _createVNode(IconComponent, { name: "up-right-from-square" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            class: _normalizeClass([
              'btn',
              { 'btn-primary': canProceed.value },
              { 'btn-secondary': !canProceed.value },
            ]),
            type: "button",
            disabled: !canProceed.value,
            onClick: fakeCheck
          }, [
            _cache[5] || (_cache[5] = _createTextVNode(" Avançar ")),
            _createVNode(IconComponent, { name: "arrow-right" })
          ], 10, _hoisted_8)
        ])
      ])
    ])
  ]))
}
}

})